import React, { useCallback } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { FormTextarea } from "@jsq/ds/forms";
import { PaymentMethod } from "#common/enums";
import {
  OtherPaymentPrefFormFields,
  OtherPaymentPrefFormSchema,
  type OtherPaymentPrefFormType,
} from "#components/PaymentPrefConsolidated/Components/OtherPaymentPrefForm/constants";
import { PaymentPrefLayoutForm } from "#components/PaymentPrefConsolidated/Components/PaymentPrefLayoutForm";
import { type ChildComponentProps } from "#components/PaymentPrefConsolidated/Components/types";
import { useConsolidatedPaymentPrefContext } from "#components/PaymentPrefConsolidated/Context";

export const OtherPaymentPrefInput: React.FC<ChildComponentProps> = ({
  onContinueClick,
  onBackClick,
  onBackButtonName,
}) => {
  const {
    otherTileConfig,
    otherPaymentPrefInstructions,
    setOtherPaymentPrefInstructions,
    workflowMode,
  } = useConsolidatedPaymentPrefContext();

  const handleSubmit = useCallback(
    (values: OtherPaymentPrefFormType) => {
      setOtherPaymentPrefInstructions(values.instructions);
      onContinueClick();
    },
    [setOtherPaymentPrefInstructions, onContinueClick],
  );

  return (
    <PaymentPrefLayoutForm
      paymentMethod={PaymentMethod.Other}
      onSubmit={handleSubmit}
      initialValues={{
        [OtherPaymentPrefFormFields.Instructions]: otherPaymentPrefInstructions ?? "",
      }}
      validationSchema={OtherPaymentPrefFormSchema}
      onBackClick={onBackClick}
      onBackButtonName={onBackButtonName}
      workflowMode={workflowMode}
      paymentMethodTextOverride={otherTileConfig?.label ?? "Other"}
    >
      <Flex flexDirection="column">
        <FormTextarea
          name={OtherPaymentPrefFormFields.Instructions}
          placeholder={otherTileConfig?.placeholder}
          isFullWidth
          size="small"
        />
        <Text variant="secondary-sm">
          {otherTileConfig?.placeholder ?? "Enter payment instructions"}
        </Text>
      </Flex>
    </PaymentPrefLayoutForm>
  );
};
